import React from 'react'

function Error() {
  return (
    <div
    className='text-center lg:mt-[300px] text-3xl text-white'
    >Error - 404 Page Not found</div>
  )
}

export default Error